class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

// Arabic search support: Shopify predictive search does not support Arabic locales reliably.
// Load the existing normalized Arabic fallback only for Arabic search queries.
(() => {
  const query = new URLSearchParams(window.location.search).get('q') || '';
  if (!/[\u0600-\u06FF]/.test(query)) return;
  if (window.__loubnaArabicSearchLoader) return;
  window.__loubnaArabicSearchLoader = true;

  const currentScript = document.currentScript;
  if (!currentScript || !currentScript.src) return;
  if (document.querySelector('script[data-loubna-arabic-search]')) return;

  const fallbackScript = document.createElement('script');
  fallbackScript.src = new URL('arabic-search-fallback.js', currentScript.src).href;
  fallbackScript.defer = true;
  fallbackScript.dataset.loubnaArabicSearch = 'true';
  document.head.appendChild(fallbackScript);
})();
